import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap-v5";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import HsCodeAdditionalService from "../../Services/HsCodeAdditionalService";
// import { EditHsCodeAdditionalFees } from "./EditHsCodeAdditionalFees";
import { FaEdit } from "react-icons/fa";
import HsCodeDutyTaxesService from "../../Services/HsCodeDutyTaxesService";
import { BiExport, BiImport } from "react-icons/bi";

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

export const HsCodeDutyTaxes = () => {
  const [show, setShow] = useState(false);
  const [item, setItem] = useState(null);
  const [loader, setLoader] = useState(true);
  const [adChargesHeader, setAdChargesHeader] = useState([]);
  const [adCharges, setAdCharges] = useState([]);

  const history = useHistory();

  const handleClose = () => setShow(false);

  const getData = () => {
    setLoader(true);
    HsCodeDutyTaxesService.getHscodeaddutytaxes().then((res) => {
      if (res.status) {
        let data = res.data;
        let sheet_data = [["HS Code"], [""]];
        for (let i = 0; i < data.length; i++) {
          sheet_data[0].push(data[i].country_name);
          sheet_data[0].push("");
          sheet_data[1].push("Duty %");
          sheet_data[1].push("Tax %");
        }

        let hsCodes = Array.from(
          new Set(data.flatMap((item) => item.data.map((dt) => dt.hs_code)))
        );

        let hsCodeDetails = {};
        data.forEach((country) => {
          country.data.forEach((item) => {
            hsCodeDetails[`${item.hs_code}_${country.country_name}`] = {
              _id: item._id,
              hs_code: item.hs_code,
              country_name: country.country_name,
              duty: item.duty,
              tax: item.tax,
            };
          });
        });

        hsCodes.forEach((hsnCode) => {
          let row = [hsnCode];
          data.forEach((country) => {
            let dutyTax = country?.data?.find((dt) => dt.hs_code === hsnCode);
            row.push(dutyTax ? dutyTax.duty : "", dutyTax ? dutyTax.vat : "");
          });
          sheet_data.push(row);
        });
        setAdCharges(sheet_data.slice(2));
        setAdChargesHeader(sheet_data.slice(0, 2));
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const onClickImport = (e) => {
    let formData = new FormData();
    formData.append("csv_file", e.target.files[0]);
    // formData.append("retailer", retailer_id);
    HsCodeDutyTaxesService.importHsCodeDutyTax(formData).then((res) => {
      if (res.status) {
        getData();
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const onClickExport = () => {
    let params = {};
    HsCodeDutyTaxesService.exportHsCodeDutyTax(params).then((res) => {
      if (res.status) {
        window.location.href = REACT_APP_API_BASEURL + "/" + res.data;
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    }).catch((error) => {
      setLoader(false);
      toast.error(error.message);
    });
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="container-fluid">
      <div className="white_box h-100">
        <div className="card p-2 h-100">
          <div className="card-body">
            {loader && <Loader isShow={loader} />}
            <div className="d-flex justify-content-end mb-3">
              <div className="d-flex justify-content-end mb-3">
                <input
                  type="file"
                  id="upload"
                  accept=".csv, .xlsx, .xls"
                  hidden
                  onChange={(e) => onClickImport(e)}
                />
                <label
                  for="upload"
                  className="btn btn-danger waves-effect waves-light mx-1 my-0"
                >
                  <BiExport className="me-1 fs-5" />
                  Upload file
                </label>
                <div>
                  <button
                    className="btn btn-success waves-effect waves-light mx-1 my-0"
                    onClick={() => onClickExport()}
                  >
                    <BiImport className="me-1 fs-5" />
                    Download file
                  </button>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              {adChargesHeader.length > 0 && adCharges.length > 0 ? (
                <table className="table table-centered table-nowrap mb-0 border text-center">
                  <thead className="table-light">
                    {adChargesHeader.map((itm, index) => (
                      <tr key={index}>
                        {itm.map((item, i) => {
                          if (i === 0 && index === 0) {
                            return (
                              <th rowSpan={2} key={i}>
                                {item || "-"}
                              </th>
                            );
                          } else if (index === 0) {
                            return item ? (
                              <th colSpan={2} key={i}>
                                {item || "-"}
                              </th>
                            ) : null;
                          } else {
                            return item ? <th key={i}>{item || "-"}</th> : null;
                          }
                        })}
                      </tr>
                    ))}
                  </thead>
                  <tbody>
                    {adCharges.map((itm, index) => (
                      <tr key={index}>
                        {itm.map((item, i) => {
                          const isFirst = i === 0;
                          const isTextValue = !isFirst && item !== null && item !== undefined && item !== '' && isNaN(Number(item));
                          const isNumericValue = !isFirst && item !== null && item !== undefined && item !== '' && !isNaN(Number(item));
                          return (
                            <td key={i} style={{ 
                              fontWeight: isFirst ? '600' : 'normal',
                              padding: '4px 8px'
                            }}>
                              {isTextValue ? (
                                <span style={{ 
                                  background: '#e0f2fe', 
                                  color: '#0369a1', 
                                  padding: '2px 8px', 
                                  borderRadius: '12px', 
                                  fontSize: '0.78rem', 
                                  fontWeight: '600',
                                  whiteSpace: 'nowrap'
                                }}>
                                  {item}
                                </span>
                              ) : isNumericValue ? (
                                <span>{item}%</span>
                              ) : (
                                item ?? '-'
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="w-10 text-center mt-2">Data Not Available</div>
              )}
            </div>
          </div>
        </div>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton className="pt-2 pb-0">
            <Modal.Title>
              <h5>Edit HS Code Additional Fees</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {item &&
              {
                /* <EditHsCodeAdditionalFees
              item={item}
              setShow={setShow}
              getData={getData}
            /> */
              }}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};
